import React from 'react'
import Reward from '../assets/images/reward.svg'

const Rewards = () => {
  return (
    <>
     <div className='bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300'>
     
        <div className="px-6 py-2">
      {/* Top Section */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 lg:py-16" style={{ backgroundImage: `url(${Reward})` }}>
        {/* Left Content */}
        <div className="max-w-2xl">
          <h1 className="text-3xl lg:text-4xl font-bold">
            Join activities and earn attractive <br />
            rewards in Rewards Hub.
          </h1>
          <p className="mt-2 text-sm">
            Grab the rewards before they run out!
          </p>

          {/* Points & Vouchers */}
          <div className="flex gap-12 mt-6">
            <div>
              <p className="text-yellow-500 text-2xl font-bold">0</p>
              <p className="text-sm">Points</p>
              <button className="text-md border p-3 rounded-lg mt-1">
                Rewards Shop &gt;
              </button>
            </div>

            <div>
              <p className="text-yellow-500 text-2xl font-bold">1</p>
              <p className="text-sm">Vouchers</p>
              <button className="text-md border p-3 mt-1 rounded-lg">
                My Vouchers &gt;
              </button>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="w-full lg:w-auto">
          {/* <img
            src={Reward}
            alt="Rewards"
            className="w-72 mx-auto lg:mx-0"
          /> */}
        </div>
      </div>

      {/* Divider */}
      <div className="border-t mt-10 pt-6">
        {/* Get Rewards Section */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Get Rewards</h2>
          <button className="text-sm underline">View More &gt;</button>
        </div>

        <p className="text-sm mb-10">
          Complete these tasks to earn daily rewards!
        </p>

        {/* No Tasks Box */}
        <div className="flex flex-col items-center text-center">
          <img
            src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f50d.svg"
            alt="No Task"
            className="w-12 h-12 mb-2"
          />
          <p className="text-sm text-gray-500">No Ongoing Tasks</p>
          <button className="text-yellow-600 text-sm mt-1 underline">
            View Past Tasks
          </button>
        </div>
      </div>
    </div>
 
        </div>   
    </>
  )
}

export default Rewards